import { Analytics } from '@genoa/analytics'

import { CreditBuilderCongrats } from './CreditBuilderCongrats'

export const CreditBuilderCongratsContainer = () => {
  return <CreditBuilderCongrats analyticsScreenName={Analytics.Screens.ONBOARDING_CONGRATS} />
}
